<header class="sf-header">
  <h1>{{ 'bookings.title' | transloco }}</h1>

  <button class="button"
    (click)="openCreateBookingModal()"
    >
    {{'bookings.empty-state.button.label'|transloco}}
  </button>
</header>

<div class="bookings">
  <div class="sf-section bookings__explanation">
    <div class="left">
      <div class="bookings__explanation-title">
        <i class="fa-solid fa-circle-question"></i>
        <h2>{{'bookings.explanation.title'|transloco}}</h2>
      </div>
      <p>{{'bookings.explanation.content'|transloco}}</p>
    </div>
  </div>

  @if (!loadingOngoingBookings) {
    @if (ongoingBookings.length > 0) {
      <div class="sf-section bookings__list">
        <h3 class="sf-section__title">{{'bookings.incoming.title'|transloco}}</h3>
        <p class="sf-section__subtitle">{{'bookings.incoming.subtitle'|transloco}}</p>
        @for (booking of ongoingBookings; track booking) {
          <app-booking-item
            [booking]="booking"
          ></app-booking-item>
        }
      </div>
    }
    @if (ongoingBookings.length === 0) {
      <div class="sf-section bookings__empty-state">
        <i class="fa-solid fa-calendar-times bookings__empty-state-icon"></i>
        <h2 class="bookings__empty-state-title">{{'bookings.empty-state.title'|transloco}}</h2>
        <p class="bookings__empty-state-subtitle">{{'bookings.empty-state.content'|transloco}}</p>
        <button class="bookings__empty-state-button button"
          (click)="openCreateBookingModal()"
          >
          {{'bookings.empty-state.button.label'|transloco}}
        </button>
      </div>
    }
  }

  @if (pastBookings && pastBookings.length > 0) {
    <div class="sf-section bookings__list">
      <h3 class="sf-section__title">{{'bookings.past.title'|transloco}}</h3>
      <p class="sf-section__subtitle">{{'bookings.past.subtitle'|transloco}}</p>
      @for (booking of pastBookings; track booking) {
        <app-booking-item
          [booking]="booking"
        ></app-booking-item>
      }
    </div>
  }
</div>

<app-create-booking-modal
  [open]="createBookingModalOpened"
  (closed)="closeCreateBookingModal($event)"
></app-create-booking-modal>
